import { Link } from 'react-router-dom';

import * as TYPES from './types'
import * as ROUTES from '../../../routes'

import { useWindowSize } from '../../../hooks/useWindowSize';

const PublicFooter: React.FC<TYPES.PublicFooterProps> = (props: TYPES.PublicFooterProps) => {
    const windowSize = useWindowSize();
    const isSmallScreen = windowSize.width < 768;

    return(
        <footer className={`gn-public-footer ${isSmallScreen ? 'text-center' : ''} m-0`}>
            <small style={{fontSize:'.8rem'}}>GameNostic &copy; 2026 - <a href="https://8circuitstudios.com" target="_blank" rel="noopener noreferrer">8 Circuit Studios</a>.</small> 
            {isSmallScreen && <br/>}
            {!isSmallScreen && <span>&nbsp;|&nbsp;</span>}
            <small style={{fontSize:'.8rem'}}>
                <Link to={ROUTES.PATH.TERMS_OF_SERVICE}>Terms of Service</Link>
                &nbsp;and&nbsp;
                <Link to={ROUTES.PATH.PRIVACY_POLICY}>Privacy Policy</Link>.
            </small>
        </footer>
    );
}
export default PublicFooter;